import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const first = document.getElementById("first-cta");
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-37" data-mp="bq9furzo3c1a">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 md:pb-5" data-id="element-38" data-mp="195wrtb2xzn8w">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-5 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_12px_32px_-6px_rgba(22,163,74,0.7)] ring-2 ring-white focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/50" data-id="element-39" data-mp="2f40z89abstp4">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-40" data-mp="1rgsvhvsjpsp7" />
            Get it now for only $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}